module.exports = __webpack_public_path__ + "static/media/8-1.2ca1fac5.jpg";